/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placedetailshowmore3Inputs */

const en_placedetailshowmore3 = /** @type {(inputs: Placedetailshowmore3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const de_placedetailshowmore3 = /** @type {(inputs: Placedetailshowmore3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr anzeigen`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Placedetailshowmore3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placedetailshowmore3 = /** @type {((inputs?: Placedetailshowmore3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placedetailshowmore3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placedetailshowmore3(inputs)
	return de_placedetailshowmore3(inputs)
});
export { placedetailshowmore3 as "placeDetailShowMore" }